var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "bg-primary", attrs: { toggleable: "md", type: "dark" } },
    [
      _c(
        "b-navbar-brand",
        { staticClass: "logo", attrs: { "b-link": "", to: "/" } },
        [
          _c("span", { staticClass: "logo-img" }),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-title" }, [
            _vm._v("client_integrations_service")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "navbar-version" }, [
            _vm._v(_vm._s(_vm.version))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-navbar-toggle",
        {
          staticClass: "jh-navbar-toggler d-lg-none",
          attrs: {
            right: "",
            href: "javascript:void(0);",
            "data-toggle": "collapse",
            target: "header-tabs",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation"
          }
        },
        [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "header-tabs" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [
                _c(
                  "span",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "home" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Home")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      attrs: {
                        right: "",
                        id: "entity-menu",
                        "active-class": "active"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "th-list" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Entities")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/crawford-product" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("CrawfordProduct")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Client")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/integration" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Integration")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/importer" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Importer")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-user" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientUser")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-user-integration" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientUserIntegration")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-product-header-map" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientProductHeaderMap")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-product-match" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientProductMatch")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-generated-product" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientGeneratedProduct")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/importer-config" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ImporterConfig")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-importer" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientImporter")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-importer-request" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientImporterRequest")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/client-importer-request-file" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("ClientImporterRequestFile")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/orders-imported" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("OrdersImported")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        { attrs: { to: "/orders-exported" } },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "asterisk" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("OrdersExported")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
                ? _c(
                    "b-nav-item-dropdown",
                    {
                      staticClass: "pointer",
                      class: {
                        "router-link-active": _vm.subIsActive("/admin")
                      },
                      attrs: {
                        right: "",
                        id: "admin-menu",
                        "active-class": "active"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "navbar-dropdown-menu",
                          attrs: { slot: "button-content" },
                          slot: "button-content"
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "cogs" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Administration")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/user-management",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "user" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("User management")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/jhi-metrics",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "tachometer-alt" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Metrics")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/jhi-health",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "heart" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Health")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/jhi-configuration",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "list" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Configuration")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/admin/audits",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "bell" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Audits")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item",
                        {
                          attrs: { to: "/admin/logs", "active-class": "active" }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "tasks" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Logs")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.swaggerEnabled
                        ? _c(
                            "b-dropdown-item",
                            {
                              attrs: {
                                to: "/admin/docs",
                                "active-class": "active"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "book" }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("API")])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-nav-item-dropdown",
                {
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/account") },
                  attrs: {
                    right: "",
                    href: "javascript:void(0);",
                    id: "account-menu",
                    "active-class": "active"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "navbar-dropdown-menu",
                      attrs: { slot: "button-content" },
                      slot: "button-content"
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "user" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n                        Account\n                    "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/settings",
                            tag: "b-dropdown-item",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "wrench" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Settings")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/account/password",
                            tag: "b-dropdown-item",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", { attrs: { icon: "lock" } }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Password")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { id: "logout", "active-class": "active" },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-out-alt" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Sign out")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: { id: "login", "active-class": "active" },
                          on: {
                            click: function($event) {
                              return _vm.openLogin()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-in-alt" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Sign in")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            to: "/register",
                            tag: "b-dropdown-item",
                            id: "register",
                            "active-class": "active"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "user-plus" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Register")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }